<template>
                <div id="search-input-content">
                    <div>
                        <img v-on:click="(e)=>searchRequest(e,'button')" width="17" height="17" src="../assets/appIcons/Icon/Search.png" alt="">
                    </div>
                    <div>
                        <input v-on:keydown="(e)=>searchRequest(e,'input')" v-model="requested" type="text" id="search-input"  placeholder="جستجو...">
                    </div>
                </div>
</template>

<script>
    export default {
        name: "SearchInput",
        data() {
            return {
                requested:null,
                running : false
            }
        },
        methods:{
            searchRequest(e,type){
                if(type === 'input'){
                    if (e.code === "Enter") {
                        this.running = true;
                    }
                }else{
                    this.running = true;
                }
                if (this.running) {
                    this.running = false;
                    let checkSpace = this.requested.replace(/\s/g, "");
                    if(checkSpace !== ""){
                        this.$router.push('/search-results/'+this.requested)
                    }
                    this.requested = null;
                }

            },
        }
    }
</script>

<style lang="scss" scoped>

    #search-input-content{
        margin-right: 0px;
        padding: 0;
        position: relative;
        width: 150px;
        height: 50px;
        border-radius: 10px;
        background-color: rgb(33,46,64)!important;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        div{
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    #search-input{
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        border: none;
        background-color: rgb(33,46,64)!important;
        color: white!important;
    }




    #search-input-content>div{
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    #search-input-content>div:nth-child(2){
        width: 100px;
        height: 50px;
        /*background-color: blue;0020*/
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        position: relative;
    }

    #search-input-content>div:nth-child(2)>input{
        left: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        text-align: right;
        background-color: #ffffff;
        opacity: 0.5;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        /*color: #ffffff;*/

    }

    #search-input-content>div:nth-child(1){
        width: 40px;
        height: 50px;
        position: relative;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }
</style>